import { ProfileRouteGuard } from './profile-route-guard';
import { CoverageRouteGuard } from './coverage-route-guard';
import { MyNeedsRouteGuard } from './my-needs-route-guard';
import { SaveRouteGuard } from './save-route-guard';
import { EmailRequiredGuard } from './email-required-guard';
import { ReferralCodeGuard } from './referral-code-guard';

export {
    ProfileRouteGuard,
    CoverageRouteGuard,
    MyNeedsRouteGuard,
    SaveRouteGuard,
    EmailRequiredGuard,
    ReferralCodeGuard
};



// WEBPACK FOOTER //
// ./src/app/shared/common/route-guard/index.ts